import React from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

function Container({
  text,
  ellipses = false,
  error = false,
  submitted = false,
}) {
  const { agentFormMaterialID } = useSelector(store => store.form);
  console.log('agentFormMaterialID: ', agentFormMaterialID);
  let textColor = 'var(--bs-gray-500)';
  if (error) textColor = 'var(--bs-danger)';
  if (submitted) textColor = 'rgba(var(--bs-success-rgb), 0.6)';

  return (
    <div
      className={`text-bold fs-5 fw-bold ${ellipses ? 'ellipses-loading' : ''}`}
      style={{
        position: 'fixed',
        zIndex: '9',
        bottom: '70px',
        left: '20px',
        width: '350px',
        height: agentFormMaterialID ? '50px' : '25px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'start',
        color: textColor,
        background: 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0px 0px 10px 10px white',
      }}
    >
      {text && (<div>{text}</div>)}
      {agentFormMaterialID && (<div className="mt-1">Material ID: {agentFormMaterialID}</div>)}
    </div>
  );
}

function SavingIndicator() {
  const {
    saving,
    saveError,
    lastSaved,
    submittedFlag,
  } = useSelector(store => store.enrollment);

  const lastSavedFormatted = moment.tz(lastSaved, moment.tz.guess()).format('HH:mm:ss z');

  let text = '';
  let showEllipses = false;
  let submitted = false;
  let error = false;
  if (saving) {
    showEllipses = true;
    text = 'Saving';
  } if (submittedFlag) {
    submitted = true;
    text = 'Submitted';
  } if (saveError) {
    error = true;
    text = 'Error saving';
  } if (!saving && lastSaved) {
    text = (
      <>
        <span className="me-1">Last save:</span>
        {lastSavedFormatted}
      </>
    );
  }
  return (
    <Container
      text={text}
      error={error}
      submitted={submitted}
      ellipses={showEllipses}
    />
  );
}

export default SavingIndicator;
